import React from 'react';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import MedicalReportDetailHungaryForm from './MedicalReportDetailHungaryForm';

interface Props {
	onSuccess: (values: FormValues) => void;
	defaultData?: any;
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	disableSubmit?: boolean;
	isMeddiCase: boolean;
}

const MedicalReportDetailHungary: React.FC<Props> = ({
	onSuccess,
	defaultData,
	disableSubmit,
	patientId,
	isMeddiCase,
}) => {
	return (
		<MedicalReportDetailHungaryForm
			onSubmit={onSuccess}
			defaultData={defaultData}
			disableSubmit={disableSubmit}
			patientId={patientId}
			isMeddiCase={isMeddiCase}
		/>
	);
};

export default MedicalReportDetailHungary;
